export default (axios) => ({
    getAll: (params) => axios.get('u/blogs?auth=benhvien16a.com', { params }).then((_) => _.data),
    getAllCategories: (params) => axios.get('u/categories?type=blog&origin=benhvien16a.com', { params }).then((_) => _.data),
    getRelates: (params) => axios.get('u/blogs/relate?auth=benhvien16a.com', { params }).then((_) => _.data),
    getMostViews: (params) => axios.get('u/blogs/most-views?auth=benhvien16a.com', { params }).then((_) => _.data),
    getShowHome: (params) => axios.get('u/blogs?showHome=true&auth=benhvien16a.com', { params }).then((_) => _.data),
});
